module.exports = __webpack_public_path__ + "img/noReplacement.80495746.jpg";